module.exports = __webpack_public_path__ + "img/8.1497eb71.png";